import Ax from './axios';
import config from './config';

// const API = 'https://www.easy-mock.com/mock/5ba36b1ba1924362236a3e0e/gov';
const API = config.BASE_API;
// 文档 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=33953056

export default function getReportData(params) {
  return Ax.get(`${API}/reportData/bikeReport`, { params });
}




// WEBPACK FOOTER //
// ./src/api/bikeDataReport.js